var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11037 2.41438C3.25099 2.12844 3.56037 1.96438 3.87443 2.00657L15.3494 3.44094L26.8244 2.00657C27.1385 1.96907 27.4479 2.13313 27.5885 2.41438L29.5432 6.32375C29.9651 7.16281 29.5151 8.18 28.6151 8.43781L20.9557 10.6269C20.3041 10.8144 19.6057 10.5378 19.2588 9.95656L15.3494 3.44094L11.4401 9.95656C11.0932 10.5378 10.3947 10.8144 9.74318 10.6269L2.08849 8.43781C1.1838 8.18 0.738492 7.16281 1.16037 6.32375L3.11037 2.41438ZM15.401 6.44094L17.9744 10.7253C18.6729 11.8878 20.0651 12.4409 21.3729 12.0659L27.3494 10.3597V18.1878C27.3494 19.2191 26.6463 20.1191 25.6432 20.3722L16.076 22.7628C15.5979 22.8847 15.0963 22.8847 14.6229 22.7628L5.05568 20.3722C4.05255 20.1144 3.34943 19.2144 3.34943 18.1831V10.355L9.33068 12.0659C10.6338 12.4409 12.0307 11.8878 12.7291 10.7253L15.2979 6.44094H15.401Z",
    fill: "#6455ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxopen);
export default __webpack_public_path__ + "static/media/Boxopen.1cd645f3c21073a203661f30e870c006.svg";
export { ForwardRef as ReactComponent };